<template>
  <div class="interaction-container">
    <div class="error-message"></div>
    <div
      class="atc-button"
      :class="{ disabled: !activeVariant.available }"
      @click="() => handleClick()"
    >
      {{ activeVariant.available ? ATC_TEXT : OUT_OF_STOCK_TEXT }}
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "VariableATC",
  props: {
    quantity: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      ATC_TEXT: "Add To Cart",
      OUT_OF_STOCK_TEXT: "Sold Out",
      ADD_ENDPOINT: "/cart/add.js?sections=cart-drawer,cart-icon-bubble",
      CART_ENDPOINT: "/cart",
      errorMessage: "TESTING",
    };
  },
  computed: {
    ...mapGetters({
      activeVariant: "products/getActiveVariant",
      activeTimeline: "shipping/getActiveTimeline",
    }),
  },
  methods: {
    handleClick() {
      if (this.activeVariant.available) {
        
        this.errorMessage = "";
        axios
          .post(this.ADD_ENDPOINT, {
            quantity: this.quantity,
            id: this.activeVariant.variantId,
          })
          .then((resp) => {
            document.dispatchEvent(new CustomEvent('cart-custom-update', {
              detail:  {
                cart: resp.data
              }
            }))
          })
          .catch((error) => {
            console.log(error);
            this.errorMessage =
              "An Unexpected Error Has Occured. Please Try Again Later.";
          });
      }
    },
  },
};
</script>
<style scoped>
.error-message:not(:empty) {
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  padding: 10px 5px;
  margin-bottom: 5px;
  border-radius: 3px;
  background: var(--error-background);
  color: var(--error-foreground);
}
.atc-button {
  background: var(--button-background);
  color: var(--button-foreground);
  cursor: pointer;
  transition: .2s ease;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  margin: 20px 0;
  padding: 8px 15px;
  border-radius: 10px;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  text-transform: uppercase;
}
.atc-button:not(.disabled):hover {
  opacity: var(--hover-opacity);
}
.atc-button.disabled {
  opacity: var(--disabled-button-opacity);
  cursor: not-allowed;
}
</style>
